import { FaMars, FaVenus, FaGenderless, FaCopy } from "react-icons/fa";

// export const mapGender = (gender) => {
//   const mapping = {"male": "M", "female": "F", }
//   if (gender == null) {
//     return "";
//   }
//   gender = gender.replace(/\w\S*/g, function (txt) {
//     return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
//   });
//   if (gender === "Male") {
//     return <FaMars className="text-blue-500 display-initial " />;
//   } else if (gender === "Female") {
//     return <FaVenus className="text-pink-500 display-initial " />;
//   } else {
//     return <FaGenderless />;
//   }
// };

export const mapGender = (gender) => {
  const mapping = { male: "M", female: "F", null: "" };

  if (mapping.hasOwnProperty(gender)) {
    return mapping[gender];
  }
  return gender;
};

export const copyToClipboard = (text, setState) => {
  navigator.clipboard.writeText(text);
  setState(true);
  setTimeout(() => {
    setState(false);
  }, 1000);
};

export const renderCopyIcon = (text, state, setState) => (
  <FaCopy
    className={`text-gray-500 opacity-50 hover:opacity-100 cursor-pointer ${state ? "animate-bounce" : ""}`}
    // style={{ fontSize: "1rem", transition: "transform 0.5s ease" }}
    onClick={() => {
      copyToClipboard(text, setState);
    }}
  />
);
